import type {
  OrderDeliveryMethod,
  OrderType,
  StatusLabel,
} from "../constants/order-display.constants";
import { getString } from "../uistringlabels/ui-string-utils";

export const statusLabelText = (statusLabel: StatusLabel): string =>
  getString(`orderDisplay.statusLabels.${statusLabel}`);

export const orderTypeLabel = (orderType: OrderType): string =>
  getString(`orderDisplay.orderTypes.${orderType}`);

export const deliveryMethodLabel = (deliveryMethod: OrderDeliveryMethod): string =>
  getString(`orderDisplay.deliveryMethods.${deliveryMethod}`);
